import React from 'react';
import { Layout } from 'fronton-react';
import cn from 'clsx';
import { Section, SectionTitle, Typography } from 'common/components';
import { KitchenDesignPanel } from '../kitchen-design-panel';
import {
  newKitchenHeaderSection,
  newKitchenHeaderSectionKz,
  newKitchenHeaderText,
  newKitchenHeaderTitle,
} from './new-kitchen-header-styles';
import { NewKitchenHeaderCard } from '../new-kitchen-header-card';

type NewKitchenHeaderProps = {
  isConsultationFormVisible: boolean;
  isRuRegion: boolean;
  signUpHref: string;
}

export const NewKitchenHeader: React.FC<NewKitchenHeaderProps> = (
  { isConsultationFormVisible, isRuRegion, signUpHref }
) => (
  <>
    <Layout>
      <Section
        className={cn({
          [newKitchenHeaderSection]: isRuRegion,
          [newKitchenHeaderSectionKz]: !isRuRegion,
        })}
      >
      <SectionTitle className={newKitchenHeaderTitle} as="h1">
        Кухни под ваши размеры быстро и&nbsp;выгодно
      </SectionTitle>
      <Typography className={newKitchenHeaderText} variant="l" size="body_long">
        Сделаем бесплатный дизайн-проект, поможем подобрать товары, привезём и&nbsp;установим кухню
      </Typography>

      {isRuRegion && <NewKitchenHeaderCard signUpHref={signUpHref} />}
    </Section>
  </Layout>

    <KitchenDesignPanel
      isConsultationFormVisible={isConsultationFormVisible}
      isRuRegion={isRuRegion}
      signUpHref={signUpHref}
      withWhiteBackground
    />
  </>
);
